const cacheRevalidateTimes = {
  // In seconds
  books: 60 * 60,
  bookDetails: 60 * 60,
  homePage: 5 * 60,
  translations: false,
  similarBooks: 60 * 60,
  cmsContent: 60 * 60 * 24,
  shippingPrice: 60 * 60
} as const

export const getCacheRevalidateTime = (key: keyof typeof cacheRevalidateTimes) => {
  const revalidateTime = cacheRevalidateTimes[key]
  if (revalidateTime === undefined) {
    throw new Error(`Cache revalidate time not defined for key: ${key}`)
  }
  return revalidateTime
}
